import { render, staticRenderFns } from "./Workdays.vue?vue&type=template&id=2328161d&"
import script from "./Workdays.vue?vue&type=script&lang=js&"
export * from "./Workdays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Workdays.vue"
export default component.exports